/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da div
 */
export default styled.div`
  position: relative;

  label {
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.56);
    display: block;
    margin-bottom: 8px;
  }

  input {
    height: 40px;
    width: ${({ width }) => `${width}px` || '324px'};
    height: ${({ height }) => `${height}px` || '40px'};
    margin-bottom: 21px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
    padding: 10px;
    box-sizing: border-box;
    padding-right: ${(props) => (props.rightAdorn ? '40px' : '10px')};
  }

  textarea {
    height: 86px;
    min-width: 324px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
    margin-bottom: 30px;
    padding: 10px;
    box-sizing: border-box;
    resize: none;
  }

  .error {
    position: absolute;
    bottom: 5px;
    color: red;
    font-size: 10px;
  }
`;
